// src/routes/AppRoutes.jsx

import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../Pages/Login";
import Dashboard from "../Pages/Dashboard";
import Logout from "../Pages/Logout";
import Teams from "../Pages/Team";
import Forbidden from "../Pages/Forbidden";
import Roles from "../Pages/Roles";
import AdminWorkspaces from "../Pages/AdminWorkspaces";
import OrganizationDetails from "../Pages/OrganizationDetails";
import ComingSoon from "../Pages/ComingSoon";
import Profile from "../Pages/Profile";
import Leads from "../Pages/Leads";
import Analytics from "../Pages/Analytics";
import MetaAdsDashboard from "../Pages/meta_ads/MetaAdsDashboard";
import Attendance from "../Pages/Attendance";
import Leave from "../Pages/Leave.jsx";
import HRSettings from "../Pages/HRSettings";
import Vault from "../Pages/Vault";
import Calls from "../Pages/Calls";
import RawCallLogs from "../Pages/RawCallLogs";
import SelfAnalysis from "../Pages/SelfAnalysis";
import ModuleGuard from "../Components/ModuleGuard";
import MainLayout from "../layouts/MainLayout";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/forbidden" element={<Forbidden />} />
      
      <Route element={<MainLayout />}>
        {/* Core Workspace - General Access */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/self-analysis" element={<SelfAnalysis />} />
        
        {/* Governance Modules */}
        <Route path="/teams" element={<ModuleGuard requiredPath="/teams"><Teams /></ModuleGuard>} />
        <Route path="/roles" element={<ModuleGuard requiredPath="/roles"><Roles /></ModuleGuard>} />
        <Route path="/organization-profile" element={<ModuleGuard requiredPath="/organization-profile"><OrganizationDetails /></ModuleGuard>} />
        
        {/* Feature Modules */}
        <Route path="/leads" element={<ModuleGuard requiredPath="/leads"><Leads /></ModuleGuard>} />
        <Route path="/meta-ads" element={<ModuleGuard requiredPath="/meta-ads"><MetaAdsDashboard /></ModuleGuard>} />
        <Route path="/attendance" element={<ModuleGuard requiredPath="/attendance"><Attendance /></ModuleGuard>} />
        <Route path="/hr-settings" element={<ModuleGuard requiredPath="/hr-settings"><HRSettings /></ModuleGuard>} />
        <Route path="/leave" element={<ModuleGuard requiredPath="/leave"><Leave /></ModuleGuard>} />
        <Route path="/vault" element={<ModuleGuard requiredPath="/vault"><Vault /></ModuleGuard>} />
        <Route path="/calls" element={<Calls />} />
        <Route path="/calls/raw" element={<RawCallLogs />} />
        
        <Route path="/workspaces-config" element={<ModuleGuard requiredPath="/workspaces-config"><AdminWorkspaces /></ModuleGuard>} />
        
        {/* Helper Paths */}
        <Route path="/coming-soon" element={<ComingSoon />} />
      </Route>
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
